module.exports = __webpack_public_path__ + "static/media/neo_insurance_white.c1df7fa3.svg";